import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-request',
  templateUrl: './request.component.html',
  styleUrls: ['./request.component.scss']
})
export class RequestComponent implements OnInit {
  constructor() { }

  ngOnInit(): void {
  }
}
